module.exports = __webpack_public_path__ + "static/media/stijnbessem-case-hollandsnieuwe-intro-card1.2.e20d964a.jpg";